/**
 * sessionStorageからの復元に失敗を表す例外
 */
export class PageStorageRestoreError extends Error {}
